import React from 'react';

import { getResourcePath, trans } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';

import { useStateMachineContext } from '@common/context/StateMachineContext';

import './Success.scss';

const Success = () => {
  const {
    send,
    payload: { name, email, priority, sosNumber }
  } = useStateMachineContext();

  const PRIORTY_MESSAGES_LOCO = {
    low: 'contact-us.success.priority.low-and-mid',
    normal: 'contact-us.success.priority.low-and-mid',
    high: 'contact-us.success.priority.high',
    urgent: 'contact-us.success.priority.urgent'
  };

  return (
    <div className="success-step">
      <p className="success-step__header">
        {trans('contact-us.success.title', {
          name
        })}
      </p>

      <div className="success-step__image">
        <img
          src={getResourcePath('/images/contact-us/contact-form-success.svg')}
          alt="success"
        />
      </div>

      <p className="success-step__priority">
        {trans(PRIORTY_MESSAGES_LOCO[priority])}
      </p>

      <p className="success-step__reach-email">
        {trans('contact-us.success.email', {
          email
        })}
      </p>

      {sosNumber && (
        <p className="success-step__sos-number">
          {trans('contact-us.success.sos-number')} {sosNumber}
        </p>
      )}

      <Button
        color="primary"
        size="large"
        fullWidth
        onClick={() => send('END')}
        className="contact-us-form__button-success"
      >
        {trans('contact-us.success.button')}
      </Button>
    </div>
  );
};

export default Success;
